import type { TMyAssignmentTracksItem } from '@crehana/compass.dashlets/my-assignment-tracks-widget';
import { format } from '@crehana/utils/date';

import type { GetMyLearningPathsQueryQuery } from './graphql/get-my-learning-paths-query.v5.generated';

export const getNodeData = (data?: GetMyLearningPathsQueryQuery) => {
  const learningPaths = data?.foundation_home_user?.get_my_learning_paths;
  return learningPaths?.__typename === 'MyLearningPathList'
    ? learningPaths
    : undefined;
};

export const getLearningPathsMap = (
  data: GetMyLearningPathsQueryQuery,
): TMyAssignmentTracksItem[] => {
  const nodeData = getNodeData(data);
  // biome-ignore lint/style/useBlockStatements: concise single-line form preferred here
  if (!nodeData?.edges) return [];

  return nodeData.edges.map(edge => ({
    id: parseInt(edge.node.id),
    title: edge.node.title || '',
    imageUrl: edge.node.image_url || '',
    progress: Math.round(edge.node.progress || 0),
    isExpired: edge.node.expired || false,
    // TODO: Set this value from the backend when the feature is ready
    isCertified: true,
    limitDate: edge.node.deadline
      ? format(edge.node.deadline, 'DD/MM/YYYY', 'YYYY-MM-DD')
      : '',
  }));
};
